<template>
  <div class="popTitle" :class="className">
    <i class="line" :style="color"></i>
    <i class="title">{{title}}</i>
  </div>
</template>
<script>

export default {
  data() {
      return {
      }
  },
  props: {
    title: {
      type: String,
      default() {
          return ''
      }
    },
    lineColor: {
      type: String,
      default() {
          return '#1C7AE5'
      }
    },
    className: {
      type: String,
      default() {
          return ''
      }
    }
  },
  methods:{
  },
  computed:{
    color() {
      return `background: ${this.lineColor} !important`
    }
  }
}
</script>

<style lang="scss" scoped>
    .popTitle {
      height: 50px;
      padding-left: 20px;
      line-height: 50px;
      border-bottom: 1px solid #f6f6f6;
      // padding: 40px 0;

      i {
        font-style: normal;
      }

      .line {
        display: inline-block;
        width: 3px;
        height: 14px;
        line-height: 1;
        background: #ccc;
        margin-right: 6px;
      }

      .title {
        display: inline-block;
        line-height: 1;
        font-size: 16px;
        color: #333333;
      }
    }
</style>
